import React from 'react';
import { Route } from 'react-router-dom';

import MeusDadosAcessos from '../../MeusDados/MeusDadosAcessos';
import MeusDadosLogs from '../../MeusDados/MeusDadosLogs';
import MeusDadosUsuario from '../../MeusDados/MeusDadosUsuario';
import MeusRelatorios from '../../MeusDados/MeusRelatorios';

const MeusDadosRoutes = () => {
  return (
    <>
      <Route path="meusdados/usuario" element={<MeusDadosUsuario />} />
      <Route path="meusdados/acessos" element={<MeusDadosAcessos />} />
      <Route path="meusdados/logs" element={<MeusDadosLogs />} />
      <Route path="meusdados/relatorios" element={<MeusRelatorios />} />
    </>
  );
};

export default MeusDadosRoutes;
